import { useQuery } from 'react-query';
import { httpService } from '../../services/http.service';
import { BASE_URL, USER } from '../../constants/endpoints';
import { HOOKS_SETTINGS } from '../constants';

const { METHOD: { POST } } = HOOKS_SETTINGS;
const {
  CONTROLLERS: {
    FINISH_SET_PIN: {
      VERSION, BASE, SUCCESS_QUERY, FAILURE_QUERY,
    },
  },
} = USER;

export const useFinishSetPinQuery = ({
  customerId, pinStatus, onSuccess, onError, cardId,
}: { customerId: string, pinStatus: number, onSuccess?: () => void, onError?: () => void, cardId:string, }) => useQuery(
  'FinishSetPin',
  async () => {
    if (!customerId || !cardId) {
      return null;
    }
    const getQuery = () => {
      switch (pinStatus) {
        case 0:
          return SUCCESS_QUERY;
        case 10:
          return FAILURE_QUERY;
        default:
          return FAILURE_QUERY;
      }
    };
    const { data } = await httpService({
      url: `${BASE_URL}/api/${VERSION}/user/${customerId}/${BASE}/${cardId}/${getQuery()}`,
      method: POST,
    });
    return data;
  },
  {
    enabled: false,
    cacheTime: 0,
    onSuccess: () => {
      if (onSuccess) onSuccess();
    },
    onError: () => {
      if (onError) onError();
    },
  },
);
